export default __webpack_public_path__ + "static/media/deficiency.27e75866.png";